import { DateUtils } from 'src/app/utils/date.utils';
import { EditableDate } from '../model/interfaces/editable-date.interface';
import { PayoffScheduleObservation } from '../model/interfaces/payoff-schedule-observation.interface';
import { PayoffSchedule } from '../model/interfaces/payoff-schedule.interface';

const getEditableDateList = (schedule: EditableDate[]) => {
  return (
    (schedule?.map((item) => DateUtils.getStringFromEditableDateObject(item))) ||
    []
  );
}

export function MapPayoffScheduleDatesToString(
  schedule: PayoffSchedule[], featureType: string
): PayoffSchedule[] {
  if (!featureType || featureType === 'NONE') {
    return []
  }

  const newSchedule = schedule ? [...schedule] : [];
  const out = newSchedule.map((item) => {
    const cleanItem = {
      ...item,
      unadjustedPaymentDate: DateUtils.getStringFromEditableDateObject(
        item.unadjustedPaymentDate as EditableDate
      ),
      adjustedPaymentDate: DateUtils.getStringFromEditableDateObject(
        item.adjustedPaymentDate as EditableDate
      ),
      accrualPeriodStart: DateUtils.getStringFromEditableDateObject(
        item.accrualPeriodStart as EditableDate
      ),
      accrualPeriodEnd: DateUtils.getStringFromEditableDateObject(
        item.accrualPeriodEnd as EditableDate
      ),
      rateDeterminationDate: DateUtils.getStringFromEditableDateObject(
        item.rateDeterminationDate as EditableDate
      ),
      ...(item.callNoticeDate && {
        callNoticeDate: DateUtils.getStringFromEditableDateObject(
          item.callNoticeDate as EditableDate
        ),
      }),
      observations: item.observations?.length
        ? item.observations.map((obs: PayoffScheduleObservation) => {
            return {
              ...obs,
              rateDeterminationDate: DateUtils.getStringFromEditableDateObject(
                obs.rateDeterminationDate as EditableDate
              ),
              rateLastResetDateForFixing: DateUtils.getStringFromEditableDateObject(
                obs.rateLastResetDateForFixing as EditableDate
              ),
              rateResetDates: getEditableDateList(
                obs.rateResetDates as unknown as EditableDate[]
              ),
              rateDeterminationDates: getEditableDateList(
                obs.rateDeterminationDates as unknown as EditableDate[]
              ),
              rateCalculationDates: getEditableDateList(
                obs.rateCalculationDates as unknown as EditableDate[]
              ),
              rateResetDatesDetail: obs.rateResetDatesDetail?.map((detail) => {
                return {
                  resetDate: DateUtils.getStringFromEditableDateObject(
                    detail.resetDate as EditableDate
                  ),
                  resetDateAfterLookback: DateUtils.getStringFromEditableDateObject(
                    detail.resetDateAfterLookback as EditableDate
                  ),
                };
              }),
              unadjustedObsStartDate: DateUtils.getStringFromEditableDateObject(
                obs.unadjustedObsStartDate as EditableDate
              ),
              unadjustedObsEndDate: DateUtils.getStringFromEditableDateObject(
                obs.unadjustedObsEndDate as EditableDate
              ),
              adjustedObsStartDate: DateUtils.getStringFromEditableDateObject(
                obs.adjustedObsStartDate as EditableDate
              ),
              adjustedObsEndDate: DateUtils.getStringFromEditableDateObject(
                obs.adjustedObsEndDate as EditableDate
              ),
              unadjustedBarrierObsDates: getEditableDateList(
                obs.unadjustedBarrierObsDates as unknown as EditableDate[]
              ),
              adjustedBarrierObsDates: getEditableDateList(
                obs.adjustedBarrierObsDates as unknown as EditableDate[]
              ),
              unadjustedBarrierFixingDates: getEditableDateList(
                obs.unadjustedBarrierFixingDates as unknown as EditableDate[]
              ),
              adjustedBarrierFixingDates: getEditableDateList(
                obs.adjustedBarrierFixingDates as unknown as EditableDate[]
              ),
              unadjustedInitialFixingDates: getEditableDateList(
                obs.unadjustedInitialFixingDates as unknown as EditableDate[]
              ),
              adjustedInitialFixingDates: getEditableDateList(
                obs.adjustedInitialFixingDates as unknown as EditableDate[]
              ),
              unadjustedFinalFixingDates: getEditableDateList(
                obs.unadjustedFinalFixingDates as unknown as EditableDate[]
              ),
              adjustedFinalFixingDates: getEditableDateList(
                obs.adjustedFinalFixingDates as unknown as EditableDate[]
              ),
            };
          })
        : [],
    };

    Object.keys(cleanItem).forEach((key) => {
      cleanItem[key] = cleanItem[key] === null ? undefined : cleanItem[key];
    });

    return JSON.parse(JSON.stringify(cleanItem));
  });
  return out;
}
